/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FirmwareLookupTableOnAzure
 */
export interface FirmwareLookupTableOnAzure {
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    latest_app_version_android: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    latest_app_version_ios: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    latest_firmware_version: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    current_manufacturing_firmware_version: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    minimum_app_version_android: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    minimum_app_version_ios: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    prototype_firmware_version: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof FirmwareLookupTableOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the FirmwareLookupTableOnAzure interface.
 */
export function instanceOfFirmwareLookupTableOnAzure(value: object): value is FirmwareLookupTableOnAzure {
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('latest_app_version_android' in value) || value['latest_app_version_android'] === undefined) return false;
    if (!('latest_app_version_ios' in value) || value['latest_app_version_ios'] === undefined) return false;
    if (!('latest_firmware_version' in value) || value['latest_firmware_version'] === undefined) return false;
    if (!('current_manufacturing_firmware_version' in value) || value['current_manufacturing_firmware_version'] === undefined) return false;
    if (!('minimum_app_version_android' in value) || value['minimum_app_version_android'] === undefined) return false;
    if (!('minimum_app_version_ios' in value) || value['minimum_app_version_ios'] === undefined) return false;
    if (!('prototype_firmware_version' in value) || value['prototype_firmware_version'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function FirmwareLookupTableOnAzureFromJSON(json: any): FirmwareLookupTableOnAzure {
    return FirmwareLookupTableOnAzureFromJSONTyped(json, false);
}

export function FirmwareLookupTableOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwareLookupTableOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'object_type': json['object_type'],
        'latest_app_version_android': json['latest_app_version_android'],
        'latest_app_version_ios': json['latest_app_version_ios'],
        'latest_firmware_version': json['latest_firmware_version'],
        'current_manufacturing_firmware_version': json['current_manufacturing_firmware_version'],
        'minimum_app_version_android': json['minimum_app_version_android'],
        'minimum_app_version_ios': json['minimum_app_version_ios'],
        'prototype_firmware_version': json['prototype_firmware_version'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function FirmwareLookupTableOnAzureToJSON(json: any): FirmwareLookupTableOnAzure {
    return FirmwareLookupTableOnAzureToJSONTyped(json, false);
}

export function FirmwareLookupTableOnAzureToJSONTyped(value?: FirmwareLookupTableOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'object_type': value['object_type'],
        'latest_app_version_android': value['latest_app_version_android'],
        'latest_app_version_ios': value['latest_app_version_ios'],
        'latest_firmware_version': value['latest_firmware_version'],
        'current_manufacturing_firmware_version': value['current_manufacturing_firmware_version'],
        'minimum_app_version_android': value['minimum_app_version_android'],
        'minimum_app_version_ios': value['minimum_app_version_ios'],
        'prototype_firmware_version': value['prototype_firmware_version'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

